/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { catchErrorAsJson } from '@fcom/rx';
import { DapiHttpResponse } from '../../dapi-http-response';
import { DapiRequestBuilder } from '../../dapi-request-builder';

import { CallerType } from '../../models/caller-type';
import { SeatmapModel } from '../../models/seatmap-model';

export interface GetSeatmapJson$Params {
  cartId?: string;
  orderId?: string;
  flightId: string;
  token?: string;
  currencyCode?: string;
  departureDateTime?: string;
  version?: number;

/**
 * Locale should be provided in 'ISO language code' or 'ISO language code'_'ISO country code' format. E.g. 'en' or 'en_US'. CoreMedia locale is supported but deprecated
 */
  locale?: string;
  rotation?: string;
  theme?: string;
  Caller?: CallerType;
}

export function getSeatmapJson(http: HttpClient, rootUrl: string, params: GetSeatmapJson$Params, context?: HttpContext): Observable<DapiHttpResponse<SeatmapModel>> {
  const rb = new DapiRequestBuilder(rootUrl, getSeatmapJson.PATH, 'get');

  if (params) {
    rb.query('cartId', params.cartId, {});
    rb.query('orderId', params.orderId, {});
    rb.query('flightId', params.flightId, {});
    rb.query('token', params.token, {});
    rb.query('currencyCode', params.currencyCode, {});
    rb.query('departureDateTime', params.departureDateTime, {});
    rb.query('version', params.version, {});
    rb.query('locale', params.locale, {});
    rb.query('rotation', params.rotation, {});
    rb.query('theme', params.theme, {});
    rb.header('Caller', params.Caller, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as DapiHttpResponse<SeatmapModel>;
    }),
    catchErrorAsJson()
  );
}

getSeatmapJson.PATH = '/api/seatmap/json';
